export function buildRoute(mainRoute: string, subRoutes: string[]): string {
  return `${mainRoute}${subRoutes.join('')}`
}